import request from '@/router/axios'
import env from '@/config/env'

// 获取分页
export const pageApi = (params) => {
  return request({
    url: env.ferryUrl + '/express/price/module/page',
    method: 'POST',
    data: params
  })
}

// 保存或编辑信息
export const moduleSave = (params) => {
  return request({
    url: env.ferryUrl + '/express/price/module/saveOrUpdate',
    method: 'post',
    data: params
  })
}

// 规则详情
export const moduleDetail = (id) => {
  return request({
    url: env.ferryUrl + `/express/price/module/info/${id}`,
    method: 'get'
  })
}
// 规则详情
export const getLines = (merchantId) => {
  return request({
    url: env.ferryUrl + `/express/price/module/getLines/${merchantId}`,
    method: 'get'
  })
}

// 禁用，启用价格模型
export const moduleEnable = (id) => {
  return request({
    url: env.ferryUrl + `/express/price/module/enable/${id}`,
    method: 'GET'
  })
}
// 禁用，启用价格模型
export const moduleRemove = (id) => {
  return request({
    url: env.ferryUrl + `/express/price/module/remove/${id}`,
    method: 'GET'
  })
}
